module.exports = __webpack_public_path__ + "static/media/CT_2019_30448A.cdab94e6.png";